import PropTypes from 'prop-types';
import React from 'react';
import linkPropTypes from '../../propTypes/link';

const ExternalLinks = ({ links, onClickLink }) => (
  <div className="sl-forecast-header-menu__external-links">
    {links.map(item => (
      <a
        key={item.text}
        className="sl-forecast-header-menu__external-link"
        href={item.path}
        target={item.newWindow ? '_blank' : ''}
        onClick={() => onClickLink(item)}
      >
        {item.text}
      </a>
    ))}
  </div>
);

ExternalLinks.propTypes = {
  links: PropTypes.arrayOf(linkPropTypes).isRequired,
  onClickLink: PropTypes.func.isRequired,
};

export default ExternalLinks;
